<template>
  <footer class="n2-pie" v-if="NOTARIA?.Theme">
    <div class="n2-contenedor n2-pie__rejilla">
      <div class="n2-pie__marca">
        <img v-if="T.Menu?.Logo" class="n2-pie__logo" :src="imagenIDtoSRC(T.Menu.Logo)" :alt="'Logo ' + NOTARIA.Nombre" loading="lazy" />
        <p class="n2-pie__nombre">{{ NOTARIA.Nombre }}</p>
        <div class="n2-redes">
          <a v-for="r in redes" :key="r.icono" :href="r.url" target="_blank" rel="noopener" :aria-label="r.nombre + ' de ' + NOTARIA.Nombre">
            <v-icon size="20">{{ r.icono }}</v-icon>
          </a>
        </div>
      </div>

      <div>
        <p class="n2-pie__titulo">{{ T.Footer?.TituloDContacto?.Texto || tituloSeccion(NOTARIA, 'Contacto', $t) }}</p>
        <ul class="n2-pie__lista">
          <li v-if="C.Direccion">
            <a :href="C.EnlaceMaps || undefined" target="_blank" rel="noopener">
              {{ C.Direccion }}<br>{{ [C.CP, C.Municipio].filter(Boolean).join(' ') }}<template v-if="C.Provincia && C.Provincia !== C.Municipio"> ({{ C.Provincia }})</template>
            </a>
          </li>
          <li v-if="C.Telefono"><a :href="'tel:' + C.Telefono.replace(/\s/g, '')">{{ C.Telefono.trim() }}</a></li>
          <li v-if="C.Movil"><a :href="'tel:' + C.Movil.replace(/\s/g, '')">{{ C.Movil.trim() }}</a></li>
          <li v-if="C.Email"><a :href="'mailto:' + C.Email">{{ C.Email }}</a></li>
          <li v-if="C.Email2"><a :href="'mailto:' + C.Email2">{{ C.Email2 }}</a></li>
          <li v-if="acceso.visible('pie')"><NuxtLink :to="acceso.enlace('pie')">{{ (acceso.textoMenu.value || tSolicitud('Encargo online')) }}</NuxtLink></li>
        </ul>
      </div>

      <div v-if="C.Horario">
        <p class="n2-pie__titulo">{{ T.Footer?.TituloHorario?.Texto || 'Horario' }}</p>
        <p class="n2-pie__horario">{{ C.Horario }}</p>
      </div>

      <div v-if="T.Footer?.MostrarMapa && coordenadas" class="n2-pie__mapa">
        <iframe :src="urlMapa" :title="'Mapa de ' + NOTARIA.Nombre" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
      </div>
    </div>

    <div class="n2-contenedor n2-pie__legal">
      <span>© {{ new Date().getFullYear() }} {{ NOTARIA.Nombre }}</span>
      <nav>
        <a :href="getLocalePath('/avisolegal')">{{ $t('avisoLegal') }}</a>
        <a :href="getLocalePath('/politicacookies')">{{ $t('politicaCookies') }}</a>
        <a :href="getLocalePath('/protecciondatos')">{{ $t('proteccionDatos') }}</a>
        <a :href="getLocalePath('/accesibilidad')">{{ $t('accesibilidad') }}</a>
        <a v-if="NOTARIA.UrlDenuncias" :href="urlExterna(NOTARIA.UrlDenuncias)" target="_blank" rel="noopener">{{ $t('denuncias') }}</a>
        <a href="https://controlpanel.unidata.es/">{{ $t('panelControl') }}</a>
      </nav>
    </div>
    <div v-if="T.Footer?.MostrarSubFooter" class="n2-contenedor n2-pie__sub">
      <FooterSubFooter />
    </div>
  </footer>
</template>

<script setup>
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useStore } from '../../store/index'
import { useUtils } from '#imports'
import { useAccesoSolicitud } from '../../composables/solicitudAcceso'
import { t as tSolicitud } from '../../composables/solicitudTextos'
import { tituloSeccion, urlExterna } from '../../composables/useNotaria2'

const store = useStore()
const { NOTARIA } = storeToRefs(store)
const { imagenIDtoSRC, $t, getLocalePath } = useUtils()
const acceso = useAccesoSolicitud()

const T = computed(() => NOTARIA.value?.Theme ?? {})
const C = computed(() => NOTARIA.value?.Contacto ?? {})

const redes = computed(() => [
  { url: C.value.Facebook, icono: 'mdi-facebook', nombre: 'Facebook' },
  { url: C.value.LinkedIn, icono: 'mdi-linkedin', nombre: 'LinkedIn' },
  { url: C.value.Twitter, icono: 'mdi-twitter', nombre: 'X' },
  { url: C.value.Instagram, icono: 'mdi-instagram', nombre: 'Instagram' },
].filter(r => r.url))

const coordenadas = computed(() => {
  const c = C.value.Coordinates
  return c && Number(c.lat) && Number(c.lng) ? c : null
})
// Mapa embebido sin clave de API; se carga solo al llegar al pie (loading="lazy")
const urlMapa = computed(() => coordenadas.value
  ? `https://maps.google.com/maps?q=${coordenadas.value.lat},${coordenadas.value.lng}&z=15&output=embed`
  : '')
</script>
